module.exports = __webpack_public_path__ + "img/creamy-desktop.a5b36f39.webp";